import { useEffect } from "react";
import { getToken, onMessage, isSupported } from "firebase/messaging";
import { messaging, db } from "../firebase/firebaseConfig";
import { doc, setDoc } from "firebase/firestore";

const AdminNotificationListener = () => {

  useEffect(() => {

    let unsubscribe;

    const initNotifications = async () => {

      const supported = await isSupported();

      if (!supported) {
        console.log("Firebase messaging not supported in this browser");
        return;
      }

      try {

        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
          console.log("Notification permission denied");
          return;
        }

        const token = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
        });

        console.log("Admin FCM Token:", token);

        if (token) {
          await setDoc(doc(db, "adminTokens", "admin"), {
            token,
            updatedAt: new Date()
          });
        }

        unsubscribe = onMessage(messaging, (payload) => {

          console.log("Notification received:", payload);

          const { title, body } = payload.notification || {};

          if (!title) return;

          const notification = new Notification(title, {
            body,
            icon: "/logo192.png"
          });

          notification.onclick = () => {
            const orderId = payload.data?.orderId;

            if (orderId) {
              window.open(`/admin/orders/${orderId}`, "_blank");
            }
          };

          const audio = new Audio("/notification.mp3");
          audio.play().catch(() => {});

        });

      } catch (error) {
        console.error("Notification setup error:", error);
      }

    };

    initNotifications();

    return () => {
      if (unsubscribe) unsubscribe();
    };

  }, []);

  return null;
};

export default AdminNotificationListener;